import {stringWithZerosIzq} from "./StringUtils";
import {getFormattedAgnoFromNow, getFormattedMesAgnoFromNow} from "./DateUtils";

/**
 *  03/03/2020 v 1.0 - JuanMa
 *
 *  v 1.1 01/06/2020 Añadido validadorPorcentual
 **/


export const validadorColor= (dato) => {
    var regex = /^#([0-9a-f]{3}){1,2}$/i
    return regex.test(dato);
}


export const validadorPorcentaje= (dato) => {
    if (isNaN(dato))
        return false;
    let valor= Number(dato);
    return valor >= 0 && valor <= 100;
}






//Formato dd:dd o d:dd
export const validadorCadenaHora= (dato) => {
    let partes= dato.split(':');
    if (partes.length != 2) {
        return false;
    }
    let hora= parseInt(partes[0]);
    console.log("hora " + hora );
    if (!hora || hora < 0 || hora > 23) {
        return false;
    }
    let minutos= parseInt(partes[1]);
    if (!minutos || minutos < 0 || minutos > 59) {
        return false;
    }
    return true;
}


export const validadorCadenaFecha=  (dato) => {
    let newCadenaFecha= "";

    //Tenemos dia 1 => 01/12/2020
    if ( (dato.length == 1 || dato.length==2)){
        if (!isNaN(dato)) {
            return true;
        }
    }

    //Tenemos diames 112 => 01/12/2020
    if ( dato.length == 3 && !dato.includes('/')){
        let dia= dato.substring(0,0);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return false;
        let mes= dato.substring(1,2);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return false;
        return true;
    }

    //Tenemos diames 0112 => 01/12/2020
    if ( dato.length == 4 && !dato.includes('/')){
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return false;
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return false;
        return true;
    }

    //Tenemos diamesaño 011220 => 01/12/2020
    if ( dato.length == 6 && !dato.includes('/')){
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return false;
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return false;
        let agno= dato.substring(4,6);
        if (isNaN(agno) || Number(agno) <= 0)
            return false;
        agno= Number(agno) + 2000;
        return true;
    }

    //tenemos dia/mes 01/12 => 01/12/2020
    if ( dato.length == 5 && dato.includes('/')){
        let partes= dato.split("/");
        if (partes.length != 2)
            return false;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return false;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return false;
        return true;
    }

    //tenemos dia/mes/año 01/12/20 => 01/12/2020
    if ( dato.length == 8 && dato.includes('/')){
        let partes= dato.split("/");
        if (partes.length != 3)
            return false;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return false;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return false;
        let agno= partes[2];
        if (isNaN(agno) || Number(agno) <= 0)
            return false;
        agno= Number(agno) + 2000;
        return true;
    }

    //tenemos dia/mes/año 01/12/2020 => 01/12/2020
    if ( dato.length == 10 && dato.includes('/')){
        let partes= dato.split("/");
        if (partes.length != 3)
            return false;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return false;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return false;
        let agno= partes[2];
        if (isNaN(agno) || Number(agno) <= 0)
            return false;
        return true;
    }

    return false;
}
